import React from 'react';
import PropTypes from 'prop-types';
import { hashHistory } from 'react-router';
import moment from 'moment-timezone';
import { Breadcrumbs } from 'react-breadcrumbs-dynamic';
import { Breadcrumb, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import EventSource from './components/EventSourceHOC';
import { DEFAULT_ROUTE } from './constants';
import { clearError } from './shared/ducks/error';
import { fetchAppConfig } from './shared/ducks/config';
import { fetchUser, logout } from './shared/ducks/session';
import { getEnvHostname } from './shared/utils/environment';
import Header from './components/Header';
import Page from './components/Page';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
// import 'react-select/dist/react-select.css';

class App extends React.Component {
    componentDidMount() {
        const { config, onLoad } = this.props;
        const configLength = Object.keys(config).length;
        const noConfig = configLength === 0;
        const isFetchingConfig = configLength === 1 && config.isFetching === false;

        if (noConfig || isFetchingConfig) {
            onLoad();
        }

        if (moment && moment.tz) {
            const selectedTimezone = localStorage.getItem('timezone');
            if (!selectedTimezone) {
                //if there is no timezone stored
                const currentTimezone = moment.tz.guess(); //get the current one from the browser
                localStorage.setItem('timezone', currentTimezone);
                moment.tz.setDefault(currentTimezone); //and set it as default
            } else {
                //if there is a timezone stored
                moment.tz.setDefault(selectedTimezone); //set it as default
            }
            console.debug(`[App] Setting timezone to ${localStorage.getItem('timezone')}.`);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { config, session, location } = this.props;
        const { router } = this.context;

        const receivedConfig =
            config.isFetching &&
            !nextProps.config.isFetching &&
            Object.keys(nextProps.config).length > 1;
        const noUserReceived = !nextProps.session.isFetching && !nextProps.session.user;
        const receivedUser = !session.user && nextProps.session.user;
        const lostUser = session.user && !nextProps.session.user;
        const sessionExpired = !session.expired && nextProps.session.expired;
        const noAccess = !session.noaccess && nextProps.session.noaccess;

        if (lostUser || sessionExpired || noAccess) {
            hashHistory.push({
                pathname: '/login',
                query: location.pathname
                    ? {
                          redirectTo: `${location.pathname}${
                              location.search ? location.search : ''
                          }`,
                      }
                    : {},
            });
        } else if (receivedConfig && noUserReceived) {
            this.props.fetchUser();
        } else if (receivedUser) {
            this.props.clearError();
            const { redirectTo } = location.query;
            router.push(redirectTo && redirectTo !== '/login' ? redirectTo : DEFAULT_ROUTE);
        }
    }

    componentWillUnmount() {
        // Clean up stuff when closing the tab/window
        localStorage.removeItem('selectedDashboardTab');
    }

    selectTimezone = eventKey => {
        localStorage.setItem('timezone', eventKey);
        moment.tz.setDefault(eventKey);
        window.location.reload();
    };

    render() {
        return (
            <div>
                {this.props.session.user && (
                    <div>
                        <EventSource
                            url={`https://${getEnvHostname()}/api/messages/abnormalities`}
                        />
                        <EventSource
                            url={`https://${getEnvHostname()}/api/messages/recovery-actions`}
                        />
                    </div>
                )}
                <Header
                    user={this.props.session.user}
                    onLogout={this.props.onLogout}
                    changeTimezone={this.selectTimezone}
                    selectedTimezone={localStorage.getItem('timezone')}
                />
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <Page>
                                <div style={{ height: 56 }}>
                                    <Breadcrumbs
                                        container={Breadcrumb}
                                        item={Breadcrumb.Item}
                                        finalProps={{ active: true }}
                                        duplicateProps={{ to: 'href' }}
                                    />
                                </div>
                                {this.props.children}
                            </Page>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

App.contextTypes = {
    router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    config: state.config,
    error: state.error,
    session: state.session,
});

const mapDispatchToProps = dispatch => ({
    clearError: () => dispatch(clearError()),
    fetchUser: () => dispatch(fetchUser()),
    onLoad: () => dispatch(fetchAppConfig()),
    onLogout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
